import { fetcher } from '@commenda/utils';

import {
  IIndirectTaxFilingV2ExportForDateRangeParams,
  IIndirectTaxFilingV2ExportJobResponse,
  IIndirectTaxFilingV2MutationResult,
} from './types';

export async function exportIndirectTaxFilingV2TaxBreakdownsForDateRange({
  params,
  token,
}: {
  params: IIndirectTaxFilingV2ExportForDateRangeParams;
  token?: string;
}): Promise<
  IIndirectTaxFilingV2MutationResult<IIndirectTaxFilingV2ExportJobResponse>
> {
  try {
    const response = await fetcher(
      'new-sales-tax/filings-v2/export/tax-breakdowns-for-date-range',
      { method: 'POST', body: params },
      token
    );
    const json = await response.json();
    if (!response.ok) {
      return {
        success: false,
        error:
          json?.message ||
          'Failed to export tax breakdowns for date range',
      };
    }
    const data: IIndirectTaxFilingV2ExportJobResponse = json;
    return { success: true, data };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error
          ? error.message
          : 'Failed to export tax breakdowns for date range',
    };
  }
}
